// @flow

import React from "react";
import { localize } from "redux-i18n";

import { View } from "@components";
import { DynamicQuestionsSection, StandardQuestionsSection } from "@modules/service/components";

type Props = {
  ...PropsFromLocalize,
  clientId: number,
};

const EventsQuestions = ({ clientId, t }: Props) => {
  return (
    <>
      <View className="message-box" margin={[0, 0, "1rem", 0]}>
        {t("QUESTIONS_INFORMATION")}
      </View>
      <View gap={5}>
        <DynamicQuestionsSection clientId={clientId} />
        <StandardQuestionsSection clientId={clientId} />
      </View>
    </>
  );
};

export default localize()(EventsQuestions);
